import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	address: {
		color: "#FFFFFF"
	},
	content: {
		margin: theme.spacing(0, 0, 4),
		"& div": {
			marginBottom: theme.spacing(4)
		},
		"& a": {
			color: "#FFFFFF",
			"&:hover": {
				color: theme.palette.secondary.light
			}
		}
	},
	phone: {
		marginBottom: theme.spacing(1)
	}
}));

export default styles;
